import { Badge, Button, Modal, ModalBody, ModalFooter, ModalHeader, Input, FormFeedback } from "reactstrap";
import { useState } from "react";

const CancelOrderModal = ({ isOpen, toggle, onConfirm, orderStatus, item }) => {
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = () => {
    if (!reason.trim()) {
      setError("Cancellation reason is required");
      return;
    }

    setError("");
    onConfirm(reason);
    setReason("");
  };

  const handleClose = () => {
    setReason("");
    setError("");
    toggle();
  };
  console.log("iter", item);
  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose}>Cancel Order</ModalHeader>

      <ModalBody>
        <p className="mb-0">
          This action will permanently cancel <strong>Order #{item?.orderNum || item?.order_no}</strong> placed by{" "}
          <strong>{item?.user?.name || item?.address?.full_name}</strong>. Are you sure you want to proceed?
        </p>

        <div className="mt-3">
          <label className="form-label">
            Cancellation Reason <span className="text-danger">*</span>
          </label>

          <Input
            type="textarea"
            rows="3"
            placeholder="Enter reason for cancellation"
            value={reason}
            invalid={!!error}
            onChange={(e) => setReason(e.target.value)}
          />

          {error && <FormFeedback>{error}</FormFeedback>}
        </div>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          No
        </Button>

        <Button color="danger" onClick={handleConfirm}>
          Yes, Cancel Order
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CancelOrderModal;
